export const LIVE_TV_THUMB = 'https://i.imgur.com/8QK6Q6B.png';
export const LIVE_TV_PLAYER = 'https://legitpro.co.in/bharat24live/bharat24live/index.m3u8';
export const PRE_VIDEO_SRC = 'https://images.firstindianews.com/addvideo/rtm.mp4?Pl1';
export const ANDROID_APP_URL = 'https://play.google.com/store/apps/details?id=com.kodecube.bharat24&hl=en&gl=US';
export const IOS_APP_URL = 'https://apps.apple.com/us/app/bharat24-live/id6473263577';
export const HEADING_STYLE_DARK_MODE = 'text-orange-400';
export const HEADING_STYLE_LIGHT_MODE = 'text-gray-900';

